import React from "react";

export const FooterTread = () => {
  const logos = [
    { src: "/partners/hitch.png", alt: "HITCH" },
    { src: "/partners/sap_b1.webp", alt: "SAP" },
    { src: "/partners/visualk-slogan.png", alt: "VisualK" },
  ];
  return (
    <footer className="relative overflow-hidden border-t bg-hitch/40">
      <style>{`
        @keyframes treadMove { 0% { background-position: 0px 0, 0 0; } 100% { background-position: 800px 0, -800px 0; } }
        @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
      `}</style>

      <div className="absolute inset-0 opacity-[0.18]" style={{ backgroundImage: "repeating-linear-gradient(115deg, rgba(255,255,255,.09) 0 10px, transparent 10px 22px), repeating-linear-gradient(65deg, rgba(255,255,255,.08) 0 10px, transparent 10px 22px)", backgroundSize: "260px 260px, 260px 260px", animation: "treadMove 18s linear infinite" }} />
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-red-500 via-red-400 bg-hitch" />
      <div className="absolute -top-4 left-0 right-0 h-8 bg-hitch/10 blur-xl" />

      <div className="relative max-w-6xl mx-auto px-6 py-10">
        <div className="flex items-center justify-center gap-3 mb-6">
          <img src="/partners/logo2.png" alt="HITCH Integradores" className="object-contain" width={180} />
        </div>
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="text-lg md:text-xl tracking-widest text-white/80">SOLUTION DAY</span>
        </div>
        <div className="mt-6 text-center text-xs text-white/50">
          © {new Date().getFullYear()} H1 Hitch  • Diseñado por HITCH Integradores
        </div>
      </div>
    </footer>
  );
};
